import { Banner } from "./Banner";
import { Options } from "./Options";
import { useClearDirty } from "./hooks/useClearDirty";
import type { TabOptions } from "./index";

interface ModalBodyProps {
  selectedTab: TabOptions;
}
export const ModalBody = ({ selectedTab }: ModalBodyProps) => {
  useClearDirty();
  return (
    <div className="react-form w-full max-w-[720px] px-4 md:px-0">
      {selectedTab === "options" && <Options />}
      {selectedTab === "banner" && <Banner />}
    </div>
  );
};
